exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f41dbc44] .tips{font-size:13px;color:#999;margin-bottom:20px;margin-left:75px}.dialog-footer[data-v-f41dbc44]{padding-top:20px;border-top:1px solid #e6ebf5;text-align:right}[data-v-f41dbc44] .el-cascader{width:100%}\n", ""]);

// exports
